import { gql } from "@apollo/client";

const GET_DEDUCTION_TYPE_CATEGORIES = gql`
  query GetDeductionTypeCategories {
    deductionTypeCategories {
      count
      items {
        deductionTypeCategoryId
        deductionTypeCategoryKey
        deductionTypeCategoryName
      }
    }
  }
`;

export default GET_DEDUCTION_TYPE_CATEGORIES;
